
/* Amethyst & Sable: prevent accidental PDP navigation after a swipe. */
(() => {
  let startX = 0, startY = 0, moved = false, activeLink = null;

  document.addEventListener('touchstart', (event) => {
    const track = event.target.closest('.as-card-swipe__track');
    activeLink = track?.closest('a.product-card__media') || null;
    moved = false;

    if (activeLink && event.touches.length === 1) {
      startX = event.touches[0].clientX;
      startY = event.touches[0].clientY;
    }
  }, { passive: true });

  document.addEventListener('touchmove', (event) => {
    if (!activeLink || event.touches.length !== 1) return;

    const dx = event.touches[0].clientX - startX;
    const dy = event.touches[0].clientY - startY;

    if (Math.abs(dx) > 12 && Math.abs(dx) > Math.abs(dy)) {
      moved = true;
    }
  }, { passive: true });

  document.addEventListener('click', (event) => {
    if (moved && activeLink && activeLink.contains(event.target)) {
      event.preventDefault();
      event.stopImmediatePropagation();
    }

    moved = false;
    activeLink = null;
  }, true);
})();
